import { pageId, isMeasurementBookEditUrl } from '../fromPhp'
import { select } from 'd3-selection'
import { iconLoading, iconError } from './icons'
import { addHint } from '../validation/hint'
import { modal } from '../components/jquery'

/**
 * @param {d3.Selection} fileDiv
 * @param {number} fileId 
 * @param {string} fileName 
 */
export function onTrashClick (fileDiv, fileId, fileName) {
  modal('#fileDeleteModal')
  select('#fileDeleteModal')
    .select('.modal-title')
    .text(`Da li ste sigurni da želite da uklonite "${fileName}" ?`)
  select('#fileRemoveConfirmButton')
    .onclick(() => removeFile(fileDiv, fileId))
}

/**
 * @param {d3.Selection} fileDiv
 * @param {number} fileId 
 */
function removeFile (fileDiv, fileId) {
  const url = isMeasurementBookEditUrl()
    ? '/measurement-book-pages/' + pageId() + '/removeFile/' + fileId
    : '/pages/' + pageId() + '/removeFile/' + fileId
  fetch(url, {
    method: 'PATCH',
    headers: {
      'X-CSRF-TOKEN': select('[name=_token]').attr('value')
    }
  }).then(handleErrors)
    .then(() => fileDiv.remove())
    .catch(error => {
      displayError(fileDiv, error)
      changeIcon(fileDiv, iconError)
    })
  changeIcon(fileDiv, iconLoading)
}

function changeIcon (fileDiv, icon) {
  fileDiv.select('.trash')
    .select('i')
    .clas(icon)
}

/**
 * @param {d3.Selection} fileDiv 
 * @param {*} error 
 */
function displayError (fileDiv, error) {
  addHint(fileDiv.node(), errorText(error), 'right')
}

function handleErrors (response) {
  if (!response.ok) {
    throw Error(response.statusText)
  }
  return response
}

function errorText (error) {
  let message = error.message
  if (error.message === 'Forbidden') {
    message = 'Zabranjeno uklanjanje fajla'
  }
  return message
}